function updateImageSize(slider) {
    let dragAxis = slider.classList.contains("slide-y-axis") ? "y" : "x";
    let compSliderSize = dragAxis === "x" ? slider.offsetWidth + "px" : slider.offsetHeight + "px";
    let resizeImg = slider.querySelector(".resize picture > img");
    if (!resizeImg) {
        resizeImg = slider.querySelector(".resize svg");
    }

    if (resizeImg) {
        if (dragAxis === "x") {
            resizeImg.style.width = compSliderSize;
        } else {
            resizeImg.style.height = compSliderSize;
        }
    }
}


function drags(dragElement, resizeElement, container, axis) {
    let touched = false;

    window.addEventListener("touchstart", function () {
        touched = true;
    });

    window.addEventListener("touchend", function () {
        touched = false;
    });

    dragElement.addEventListener("mousedown", dragStart);
    dragElement.addEventListener("touchstart", dragStart);

    function dragStart(e) {
        e.preventDefault();
        dragElement.classList.add("draggable");
        resizeElement.classList.add("resizable");

        let startPos = axis === "x" ? (e.pageX || e.touches[0].pageX) : (e.pageY || e.touches[0].pageY);
        let dragSize = axis === "x" ? dragElement.offsetWidth : dragElement.offsetHeight;
        let pos = (axis === "x" ? dragElement.getBoundingClientRect().left : dragElement.getBoundingClientRect().top) + dragSize - startPos;
        let containerOffset = axis === "x" ? container.getBoundingClientRect().left : container.getBoundingClientRect().top;
        let containerSize = axis === "x" ? container.offsetWidth : container.offsetHeight;
        let minLimit = containerOffset + 10;
        let maxLimit = containerOffset + containerSize - dragSize - 10;

        function moveHandler(e) {
            if (!touched) {
                e.preventDefault();
            }

            let movePos = axis === "x" ? (e.pageX || e.touches[0].pageX) : (e.pageY || e.touches[0].pageY);
            let newPos = movePos + pos - dragSize;

            if (newPos < minLimit) {
                newPos = minLimit;
            } else if (newPos > maxLimit) {
                newPos = maxLimit;
            }

            let sizeValue = ((newPos + dragSize / 2 - containerOffset) * 100) / containerSize;

            if (axis === "x") {
                dragElement.style.left = sizeValue + "%";
                if (window.enableRtl) {
                    resizeElement.style.width = 100 - sizeValue + "%";
                } else {
                    resizeElement.style.width = sizeValue + "%";
                }
            } else {
                dragElement.style.top = sizeValue + "%";
                resizeElement.style.height = sizeValue + "%";
            }
        }

        function stopDrag() {
            dragElement.classList.remove("draggable");
            resizeElement.classList.remove("resizable");
            document.removeEventListener("mousemove", moveHandler);
            document.removeEventListener("touchmove", moveHandler);
            document.removeEventListener("mouseup", stopDrag);
            document.removeEventListener("touchend", stopDrag);
            document.removeEventListener("touchcancel", stopDrag);
        }

        document.addEventListener("mousemove", moveHandler);
        document.addEventListener("touchmove", moveHandler);
        document.addEventListener("mouseup", stopDrag);
        document.addEventListener("touchend", stopDrag);
        document.addEventListener("touchcancel", stopDrag);
    }
}

function initImageCompare(compSliders) {
    if (compSliders.length > 0) {
        compSliders.forEach((slider) => {
            let image = slider.querySelector('.after-image') || slider.querySelector('.placeholder-after-image');
            if (image) {
                image.onload = () => {
                    updateImageSize(slider);
                }
            }


            let divider = slider.querySelector(".divider");
            let resize = slider.querySelector(".resize");

            if (divider && resize) {
                drags(divider, resize, slider, slider.classList.contains("slide-y-axis") ? "y" : "x");
            }
        });

        window.addEventListener("resize", () => {
            compSliders.forEach(updateImageSize);
        });
    }
}

if (Shopify.designMode) {
    initImageCompare(document.querySelectorAll(".comparison-slider"))
    document.addEventListener('shopify:section:load', () => {
        initImageCompare(document.querySelectorAll(".comparison-slider"))
    })
} else {
    document.addEventListener('DOMContentLoaded', () => {
        let compSliders = document.querySelectorAll(".comparison-slider");
        initImageCompare(compSliders)
    });
}
